import { Toaster } from "@pathwright/ux/src/components/chakra/ui/toaster"
import { ReactNode } from "react"
import { createGlobalStyle } from "styled-components"
import { GlobalThemeStyles } from "../pathwright/GlobalSchoolThemeStyles"
import { PathwrightClient } from "../pathwright/PathwrightClient"
import { PathwrightContextProvider } from "../pathwright/PathwrightContext"
import ChakraThemeProvider from "../theme/ChakraThemeProvider"

type StandaloneEmbedWrapperProps = {
  schoolId: number
  children: ReactNode
}

const EmbedGlobalStyles = createGlobalStyle`
  html,
  body,
  #root {
    background-color: transparent !important;
  }

  .loading-splash {
    display: none !important;
    opacity: 0 !important;
  }
`

const StandaloneEmbedWrapper = ({
  schoolId,
  children
}: StandaloneEmbedWrapperProps) => (
  <PathwrightClient schoolId={schoolId}>
    <PathwrightContextProvider>
      <ChakraThemeProvider resetCSS>
        <>
          <EmbedGlobalStyles />
          <GlobalThemeStyles />
          <Toaster />
          {children}
        </>
      </ChakraThemeProvider>
    </PathwrightContextProvider>
  </PathwrightClient>
)

export default StandaloneEmbedWrapper
